import { useCallback, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function usePaginationQuery() {
  // util
  const [searchParams, setSearchParams] = useSearchParams();

  // default
  const defaultPageValue = useMemo(() => {
    const pageString = searchParams.get('page');
    const pageSizeString = searchParams.get('pageSize');

    return {
      page: pageString ? Number(pageString) : 1,
      pageSize: pageSizeString ? Number(pageSizeString) : 10,
    };
  }, [searchParams]);

  // state
  const [page, setPage] = useState(defaultPageValue.page);
  const [pageSize, setPageSize] = useState(defaultPageValue.pageSize);

  const handlePageChange = useCallback(
    (page: number, pageSize: number, isParamsChange = true) => {
      if (isParamsChange) {
        searchParams.set('page', String(page));
        searchParams.set('pageSize', String(pageSize));

        setSearchParams(searchParams, { replace: true });
      }

      setPage(page);
      setPageSize(pageSize);
    },
    [searchParams, setSearchParams],
  );

  const reset = useCallback(() => {
    const resetPage = 1;
    const resetPageSize = 10;

    setPage(resetPage);
    setPageSize(resetPageSize);
    searchParams.set('page', String(resetPage));
    searchParams.set('pageSize', String(resetPageSize));

    setSearchParams(searchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return {
    page,
    pageSize,
    handlePageChange,
    reset,
  };
}
